<template>
    <div class="drag-pipeline-row" :id="item._id">
        <div class="drag-pipeline-row-card" :type="pipeline.type" :class="[selected && 'selected']">
            <div class="row-check">
                <a-checkbox class="kanban-checkbox" v-model="selected" @change="(e) => check(item, e)" />
            </div>
            <div class="content">
                <div class="task-head">
                    <div class="task-title">
                        {{ item.title }}
                    </div>
                    <a-popover
                        overlayClassName="task-more-options"
                        trigger="click"
                        placement="bottomRight"
                        class="kanban-task-edit-popover"
                    >
                        <div slot="content">
                            <div class="options-item" @click="edit(item)">
                                <div class="material-icons">edit</div>
                                Edit
                            </div>
                            <div class="bracket"></div>
                            <div class="options-item" @click="deleteTaskModalOpen(item)">
                                <div class="material-icons">delete</div>
                                Delete
                            </div>
                        </div>
                        <div class="task-more material-icons">more_vert</div>
                    </a-popover>
                </div>
                <div class="kanban-task-details" @click="view">
                    <div class="task-users">
                        <Avatar
                            v-for="userId of getUserIds(item)"
                            :size="25"
                            :key="userId"
                            :src="users[userId].gravatar"
                            :username="users[userId].name"
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="users[userId].email"
                        />
                    </div>
                    <div class="kanban-task-alt-items">
                        <div class="kanban-task-alt-items-item" v-if="(item.subTasks || []).length > 0">
                            <div class="material-icons">account_tree</div>
                            {{ getComplatedParentTaskCount(item) }}/{{ (item.subTasks || []).length }}
                        </div>
                        <div class="kanban-task-alt-items-item" v-if="item.checklist.length > 0">
                            <div class="material-icons">library_add_check</div>
                            {{ getComplatedChecklistCount(item) }}/{{ item.checklist.length }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Avatar from "vue-avatar";
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "TaskColCard",
    props: {
        item: {
            type: Object,
            default: {},
        },
        pipeline: {
            type: Object,
            default: {},
        },
    },
    components: {
        Avatar,
    },
    data: () => ({
        selected: false,
    }),
    computed: {
        ...mapState({
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            checkedItems: (state) => state.tasks.checkedTasks,
        }),
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            setCheckedTasks: "tasks/setCheckedTasks",
        }),
        getUserIds(item) {
            return _.uniq([item.assignees, item.collaborators, item.followers, item.owner].flat()).filter((c) => c);
        },
        getCompletedParentTaskCount(item) {
            return (item.subTasks || []).filter((item) => item.completed).length;
        },
        getCompletedChecklistCount(item) {
            return item.checklist.filter((item) => item.isCompleted).length;
        },
        view() {
            this.addNewWindow({
                type: "editor-task",
                title: this.item.title,
                details: {
                    taskId: this.item._id,
                },
            });
        },
        check(item, e) {
            this.setCheckedTasks({
                ...this.checkedItems,
                [item._id]: e.target.checked,
            });
        },
        edit() {
            this.addNewWindow({
                type: "edit-task",
                title: "Edit Task",
                details: {
                    taskId: this.item._id,
                },
            });
        },
        deleteTaskModalOpen(item) {
            this.$emit("delete-item", item);
        },
    },
    watch: {
        checkedItems: {
            deep: true,
            handler() {
                this.selected = this.checkedItems[this.item._id];
            },
        },
    },
};
</script>
<style lang="scss">
.task-more-options {
    padding-top: 0 !important;
    .ant-popover-arrow {
        display: none !important;
    }
    .ant-popover-inner-content {
        box-shadow: none !important;
    }
    .ant-popover-inner-content {
        padding: 5px 0px;
    }
    .options-item {
        width: 200px;
        display: flex;
        align-items: center;
        padding: 5px 10px;
        gap: 10px;
        font-weight: 500;
        font-size: 15px;
        color: #55555a;
        cursor: pointer;
        &:hover {
            background-color: #f1f3f9;
        }
        .material-icons {
            color: #91a2b6;
        }
    }
    .bracket {
        width: 100%;
        height: 1px;
        margin: 3px 0px;
        background-color: #e6e9f2;
    }
}
</style>
